import formatWithOptions from 'date-fns/fp/formatWithOptions';
import { ru } from './locale';
export const format = formatWithOptions({
  locale: ru
});